import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { DialogTitle } from './DialogTitle';
import { Choice } from './Choice';

ChooserDialog.propTypes = {
  title: PropTypes.string,
  direction: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onCancel: PropTypes.func.isRequired,
  onChoose: PropTypes.func.isRequired,
};

export function ChooserDialog({
  onCancel,
  onChoose,
  options,
  title = 'Export Rx',
  direction = 'Select the prescription you wish to download',
}) {
  const [choices, setChoices] = useState([]);
  const [isSaving, setSaving] = useState();

  return (
    <Dialog
      keepMounted
      open
      maxWidth="sm"
      PaperProps={{ sx: { width: '500px', px: 5, pb: 5 } }}
    >
      <Box
        sx={{ backgroundColor: 'primary.main', height: 8, mx: -5, mb: 1.5 }}
      />
      <DialogTitle onClose={onCancel} title={title} sx={{ px: 0, mr: -1.5 }} />
      <DialogContent sx={{ p: 0, mb: 5 }}>
        <Typography variant="body1" sx={{ mt: 1 }}>
          {direction}
        </Typography>
        {buildChoices()}
      </DialogContent>
      <DialogActions sx={{ p: 0 }}>
        <Button
          sx={{ mr: 1 }}
          onClick={onCancel}
          variant="contained"
          color="dark"
        >
          Cancel
        </Button>
        <LoadingButton
          onClick={saveChoice}
          variant="contained"
          color="primary"
          disabled={!choices.length}
          loading={isSaving}
        >
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );

  function buildChoices() {
    return (
      <Box
        component="ul"
        sx={{
          width: '100%',
          listStyle: 'none',
          p: 0,
          '& li': { width: '100%' },
          '& li + li': { mt: 2 },
        }}
      >
        {options.map((option, key) => (
          <Choice
            option={option}
            key={key}
            onSelect={(choice) => setChoices([choice])}
            isSelected={choices.includes(option.value)}
          />
        ))}
      </Box>
    );
  }

  function saveChoice(event) {
    setSaving(true);
    onChoose(event, ...choices);
  }
}
